<div class="modal-header border-bottom-0 py-1 d-flex justify-content-between" *ngIf="!modalData.hiddeHeader">
  <h5 class="modal-title" *ngIf="modalData?.title">{{ modalData.title }}</h5>
  <span></span>
  <div>
    <button type="button" class="btn p-0 me-2" (click)="resize()" *ngIf="modalData?.showMaximize">
      <i class="bi" [ngClass]="maximized ? 'bi-chevron-compact-down' : 'bi-square'"></i>
    </button>
    <button type="button" class="btn p-0 px-1" (click)="activeModal.close()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
<div class="modal-body p-0">
  <ng-container #modalContent></ng-container>
</div>
<div class="modal-footer py-1 border-top-0" *ngIf="modalData?.showButtons || modalData?.confirmButton || modalData?.cancelButton">
  <button type="button" class="btn btn-sm btn-outline-primary" (click)="activeModal.close()"
    *ngIf="modalData?.showButtons || modalData?.cancelButton">
    {{ modalData.cancelButton || 'Cancelar'}}</button>
  <button type="button" class="btn btn-sm btn-primary" (click)="activeModal.close(outData)"
    *ngIf="modalData?.showButtons || modalData?.confirmButton">
    {{modalData.confirmButton || 'Aceptar'}}</button>
</div>